import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Traduce il nome di una regione o di un distretto/provincia (così come il
 * backend lo salva, es. "Durrës", "Vlorë", "Apulia") nella lingua attiva,
 * usando le chiavi `geo.<nome>` generate da scripts/generate-geo-i18n.cjs.
 *
 * Impure come `countryName`: si riallinea al cambio lingua e al caricamento
 * asincrono dei file i18n. Se il nome non è mappato restituisce il nome grezzo.
 */
@Pipe({ name: 'placeName', standalone: true, pure: false })
export class PlaceNamePipe implements PipeTransform {
  constructor(private readonly translate: TranslateService) {}

  transform(name?: string | null): string {
    if (!name) {
      return '';
    }
    const key = `geo.${name.trim()}`;
    const translated = this.translate.instant(key);
    return translated && translated !== key ? translated : name;
  }
}
